/*
 * @Author: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @LastEditors: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @Description: file content
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

@BindAll()
export class BusinessPriceQuotationReviewDetailController<
  T = any,
> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      pagination: EnumAPI.business_priceQuotationReview_detail,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        // response: {
        //   total: 'total',
        //   dataSource: 'records',
        //   valueGetter: this.valueGetter,
        // },
      },
      details: EnumAPI.business_priceQuotationReview_detail,
    });
  }
  valueGetter(res) {
    const dataSource = lodash.get(res, 'records');
    const total = lodash.get(res, 'total');
    return {
      dataSource,
      total,
    };
  }
  currentCardStatus = -1;

  async onDeleteProduct(id) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotationReview_deleteProduct, {
        body: { id },
      }),
    );
  }

  async onAddProduct(body) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotationReview_productChange, {
        body,
      }),
    );
  }

  async onReplaceProduct(body) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotationReview_replaceProduct, {
        body,
      }),
    );
  }

  async onUpdateProduct(body) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotationReview_updateProduct, {
        body,
      }),
    );
  }

  async onApproveProduct(body) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotationReview_approve, {
        body,
      }),
    );
  }
}
